export default __webpack_public_path__ + "assets/images/5bbc8751c09e298eb9c54517dd1be47d.png";